import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import ContactSection from '@/pages/home/components/ContactSection';
import AppSection from '@/pages/home/components/AppSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CardsSection from '@/pages/home/components/CardsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import MediaSection from '@/pages/home/components/MediaSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import IndexSection from '@/pages/home/components/IndexSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <ContactSection />
        <AppSection />
        <FaqSection />
        <CardsSection />
        <RankingSection />
        <FeaturesSection />
        <MediaSection />
        <UpdatesSection />
        <AboutSection />
        <CarouselSection />
        <CommentsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}